import { Factory } from '../../services/Factory';
import { JsonCellRenderer } from '../../directives/controls/grid/renderers/jsonCellRenderer';

namespace app.controllers.project {

  interface IProjectAdminScope extends angular.IScope {
    DisplayMode;
    StorageMagnitude;
    Status;
    Type;
    tab: string;
    billing;
    accounts: Array<any>;
    project: any;
    roles: Array<any>;
    passwords: Array<String>;
    generatingBillingReport: boolean;
    detailForm: { saving: boolean };
    newPassword: { password: string };
    savingPassword: boolean;
    formatY: (value) => string;
  }

  export class ProjectAdminController {
    constructor($scope: IProjectAdminScope, $rootScope: IRootScope, $routeParams, $uibModal, $location, httpService: app.services.IHttpWrapperService, collectionService: app.services.collections.CollectionService, organizationService: app.services.organization.OrganizationService, projectService: app.services.project.ProjectService, notificationService: app.services.INotificationService, navigationService, accountService: app.services.account.AccountService, inviteService, projectPasswordService: app.services.project.ProjectPasswordService, roleService: app.services.authentication.RoleService, permissionService: app.services.authentication.PermissionService, loadFileFormatService: app.services.exporting.LoadFileFormatService, projectStatusService: app.services.project.ProjectStatusService, billingService: app.services.collections.BillingService, auditLogService: app.services.auditing.AuditLogService, reportService: app.services.reporting.ReportService, configService: app.services.IConfigService, $sce: angular.ISCEService) {
      navigationService.setActiveTab("projects", "admin");
      collectionService.ClearCurrentCollection();

      $rootScope.$broadcast("navigation.batch.deselect");

      $scope.DisplayMode = app.model.user.DisplayMode;
      $scope.StorageMagnitude = app.StorageMagnitude;
      $scope.Status = app.model.project.Status;
      $scope.formatY = value => app.Utilities.formatBytes(value);
      $scope.Type = app.model.project.ProjectType;
      $scope.tab = null;
      $scope.paidServiceMessage = $sce.getTrustedHtml("This is a <span class='label label-warning'>PAID</span> service. Enabling this feature will incur additional charges. <br/><br/> Please contact <a href='mailto:sales@indexed.io'>sales@indexed.io</a> for more information.")
      $scope.UsageTypes = [{id: app.model.project.UsageType.Processing, name: Object.keys(app.model.project.UsageType)[0]}, {
        id: app.model.project.UsageType.ECA,
        name: Object.keys(app.model.project.UsageType)[1]
      }, {id: app.model.project.UsageType.Review, name: Object.keys(app.model.project.UsageType)[2]}];
      $scope.billing = {};
      $scope.username = accountService.GetEmail();

      $scope.generatingBillingReport = false;

      $scope.detailForm = {
        saving: false
      };

      $scope.newPassword = {
        password: ""
      };

      $scope.accountService = accountService;
      $scope.account = accountService.Get();

      $scope.permissions = {
        available: []
      };

      $scope.newLoadFileFormat = {
        saving: false,
        projectId: ""
      };
      $scope.checkedLoadFileFormats = [];

      $scope.project = null;

      $scope.sftp = {
        host: 'sftp2.indexed.io',
        port: 22,
        username: 'project-' + $routeParams.projectId,
        password: '••••••••'
      };
      $scope.showPassword = false;
      $scope.loadingPassword = false;

      $scope.columnDefinitions = [];
      $scope.totalResources = 0;
      $scope.totalPageCount = 0;
      $scope.totalFileSize = 0;
      $scope.columnFilters = {};
      $scope.sortModel = [{
        colId: "date",
        sort: "desc"
      }];
      $scope.columnDefinitions = [
        {
          headerName: "Date",
          field: "formattedLocalDate",
          colId: "date",
          width: 200,
          filter: "agDateColumnFilter",
          cellRenderer: params => `<i class="fas fa-clock-o"></i>${(params.data ? params.data.formattedLocalDate : "")}`
        },
        {
          headerName: "Email",
          field: "user",
          width: 250,
          filter: false,
          cellRenderer: params => `<i class="fas fa-user-circle-o"></i> ${params.data ? params.data.user : ""}`
        },
        {
          headerName: "IP Address",
          field: "ipAddress",
          width: 250,
          filter: false,
          cellRenderer: params => `${params.data ? params.data.ipAddress : ""}`
        },
        {
          headerName: "Action",
          field: "actionDescription",
          width: 200,
          filter: false,
          cellRenderer: params => `<span class="label label-default ng-binding">${params.data ? params.data.actionDescription : ""}</span>`
        },
        {
          headerName: "Action Details",
          field: "actionDetails",
          filter: false,
          sortable: false,
          cellRenderer: JsonCellRenderer
        }
      ];

      $scope.enableColumnPreferences = false;

      $scope.pagination = {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
        limit: 20,
        gridLimit: 100,
        filterString: ""
      };

      const refreshInvites = async () => {
        $scope.accounts = await accountService.FindByProject($scope.project);
        // We want to operate on a copy of the role id, instead of changing the actual role id in the dropdown
        $scope.accounts.forEach(account => account.currentProjectRoleId = account.projectRole.id);

        inviteService.findByProject($scope.project, invites => $scope.invites = invites);
      };

      const refreshPasswords = () => projectPasswordService.FindAll($routeParams.projectId).then(passwords => $scope.passwords = passwords);

      const refreshRoles = () => roleService.findByProjectId($routeParams.projectId, roles => $scope.roles = roles);

      const refreshStatus = () => projectStatusService.FindAll($scope.project).then(statuses => $scope.statuses = statuses);

      $scope.revealPassword = function() {
        $scope.errorText = '';

        // toggle back to hidden without hitting the server
        if ($scope.showPassword) {
          $scope.showPassword = false;
          $scope.sftp.password = '••••••••';
          return;
        }

        $scope.loadingPassword = true;

        projectService.GetSftpPassword($scope.project, (response: any) => {
          $scope.sftp.password = response.password;
          $scope.showPassword = true;
        }, (err) => {
          console.error('Password fetch error:', err);
        }, () => {
          $scope.loadingPassword = false;
        });
      };

      $scope.copyToClipboard = function(value) {
        if (!value) return;
        const temp = document.createElement('input');
        temp.value = value;
        document.body.appendChild(temp);
        temp.select();
        document.execCommand('copy');
        document.body.removeChild(temp);
        console.log('Copied:', value);
      };

      $scope.refreshAuditLog = () => {
        $scope.dataSource = {
          rowCount: null,
          getRows: params => {
            auditLogService.FindAll({
              projectId: $routeParams.projectId,
              page: Math.floor(params.startRow / $scope.pagination.gridLimit),
              limit: $scope.pagination.gridLimit,
              sortOperations: _.map(params.sortModel, (v: any) => {
                return {sortBy: v.colId, sortDirection: v.sort.toUpperCase()};
              })
            }).then((auditRecordsPage: any) => {
              $scope.totalRecords = auditRecordsPage.totalRecords;
              $scope.totalPageCount = auditRecordsPage.totalPageCount;
              _.each(auditRecordsPage.records, (r: any) => {
                r.formattedLocalDate = moment.tz(moment.utc(r.date), moment.tz.guess()).format("MM/DD/YYYY, h:mm:ss a");
              });
              params.successCallback(auditRecordsPage.records, auditRecordsPage.totalRecords);
            });
          }
        };
      };

      projectService.FindOneOrCurrentProject({id: $routeParams.projectId}).then(async (project: any) => {
        $scope.project = project;
        $scope.usageType = _.find(Object.keys(app.model.project.UsageType), k => k.toLowerCase() === project.usageType);

        if (project.status !== app.model.project.Status.Active) {
          $scope.project.redactionBoxWhite = false;
        }

        if (project.type === "organization_project") {
          $scope.organization = await organizationService.FindOne({ id: project.organizationId });
        }

        projectService.SetCurrentProject(project);

        billingService.GetByCurrentBillingCycle(project.id).then(result => {
          $scope.billing = result.data;
          $scope.billing.period.startDate = new Date(moment($scope.billing.period.startDate).utc().format("YYYY-MM-DDThh:mm:ss"));
          $scope.billing.period.endDate = new Date(moment($scope.billing.period.endDate).utc().format("YYYY-MM-DDThh:mm:ss"));
          $scope.dailyBillingStats = [
            _.flatten(["x", _.map(result.data.dailyStatistics, (stats: any) => stats.date)]),
            _.flatten(["Processing", _.map(result.data.dailyStatistics, (stats: any) => stats.processingBytes)]),
            _.flatten(["Hosting", _.map(result.data.dailyStatistics, (stats: any) => stats.rollingHostingBytes)])
          ];
        });

        $scope.refreshAuditLog();
        refreshInvites();
        refreshPasswords();
        refreshStatus();
      });

      $scope.$watch("tab", value => value === "audit" && $scope.refreshAuditLog(), true);

      $scope.getNextBillingPeriod = () => {
        const date = moment.utc($scope.billing.period.startDate).add(1, "months");

        $scope.billing.period.startDate = date.startOf("month").toDate();
        $scope.billing.period.endDate = date.endOf("month").toDate();

        billingService.GetByDateRange($scope.project.id, $scope.billing.period.startDate, $scope.billing.period.endDate).then(result => {
          $scope.billing = result.data;
          $scope.billing.period.startDate = new Date(moment($scope.billing.period.startDate).utc().format("YYYY-MM-DDThh:mm:ss"));
          $scope.billing.period.endDate = new Date(moment($scope.billing.period.endDate).utc().format("YYYY-MM-DDThh:mm:ss"));
          $scope.dailyBillingStats = [
            _.flatten(["x", _.map(result.data.dailyStatistics, (stats: any) => stats.date)]),
            _.flatten(["Processing", _.map(result.data.dailyStatistics, (stats: any) => stats.processingBytes)]),
            _.flatten(["Hosting", _.map(result.data.dailyStatistics, (stats: any) => stats.rollingHostingBytes)])
          ];
        });
      };

      $scope.getPreviousBillingPeriod = () => {
        const date = moment.utc($scope.billing.period.startDate).add(-1, "months");

        $scope.billing.period.startDate = date.startOf("month").toDate();
        $scope.billing.period.endDate = date.endOf("month").toDate();

        billingService.GetByDateRange($scope.project.id, $scope.billing.period.startDate, $scope.billing.period.endDate).then(result => {
          $scope.billing = result.data;
          $scope.billing.period.startDate = new Date(moment($scope.billing.period.startDate).utc().format("YYYY-MM-DDThh:mm:ss"));
          $scope.billing.period.endDate = new Date(moment($scope.billing.period.endDate).utc().format("YYYY-MM-DDThh:mm:ss"));
          $scope.dailyBillingStats = [
            _.flatten(["x", _.map(result.data.dailyStatistics, (stats: any) => stats.date)]),
            _.flatten(["Processing", _.map(result.data.dailyStatistics, (stats: any) => stats.processingBytes)]),
            _.flatten(["Hosting", _.map(result.data.dailyStatistics, (stats: any) => stats.rollingHostingBytes)])
          ];
        });
      };

      $scope.getAuditCSV = () => {
        $scope.generatingAuditReport = true;
        const report = reportService.Create({
          projectId: $scope.project.id,
          type: "audit_log_report",
          name: "Audit Log Report",
          format: "csv",
          multiValueCharCode: "0",
          dateTimeFormat: "yyyy-MM-dd",
          hasHeaderRow: false,
          fields: []
        });

        notificationService.addSuccess({
          title: "Report started",
          description: `Name: Audit Log Report`,
          timeout: 5000
        });

        reportService.Save(report).then(() => {
          $scope.generatingAuditReport = false;
          $scope.close();
        }).catch(() => $scope.generatingAuditReport = false);
      };

      $scope.getBillingCSV = () => {
        $scope.generatingBillingReport = true;
        billingService.GetCSV($scope.project.id, $scope.billing.period.startDate, $scope.billing.period.endDate);
      };

      $scope.$on("FeedService.BillingReportComplete", (e, result) => {
        $scope.generatingBillingReport = false;
        notificationService.addSuccess({
          title: "Report available",
          description: "Billing Report has completed.",
          buttons: `<a class="btn btn-success" href="${result}"><i class="icon-download-alt"></i> Download</a>`
        });
      });

      projectService.FindAll({}).then(projects => $scope.projects = projects);

      projectService.GetTimeZoneIds().then(response => $scope.timezoneIds = response.data);

      permissionService.findByProjectId($routeParams.projectId, permissions => {
        $scope.permissions.available = permissions;
        refreshRoles();
      });

      $scope.saveProject = () => {
        $scope.detailForm.saving = true;

        projectService.UpdateProject($scope.project).then(() => {
          $scope.detailForm.saving = false;

          notificationService.addSuccess({
            title: "Project Details Updated",
            description: "",
            timeout: 5000
          });

          $scope.$applyAsync();
        });
      };

      $scope.OpenCreditCardDialog = () => {
        $uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/dialog_credit_card.html",
          controller: "CreditCardModalController",
          scope: $scope,
          resolve: {
            project: () => $scope.project,
            message: () => ""
          }
        });
      };

      $scope.openInviteUserDialog = () => {
        const modalInstance = $uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/dialog_add_user.html",
          controller: "AddUserModalCtrl",
          scope: $scope,
          resolve: {
            project: () => $scope.project,
            roles: () => $scope.roles
          }
        });

        modalInstance.result.then(() => refreshInvites());
      };

      $scope.openRequestReviewerDialog = () => {
        const modalInstance = $uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/dialog_request_reviewer.html",
          controller: "RequestReviewerModalCtrl",
          scope: $scope,
          resolve: {
            project: () => $scope.project
          }
        });

        modalInstance.result.then(() => refreshInvites());
      };

      $scope.unInviteAccount = account => accountService.RemoveFromProject($scope.project, account, account.projectRole, () => refreshInvites(), e => console.error(e));

      $scope.unInvite = invite => inviteService.delete(invite, () => refreshInvites());

      $scope.updateRole = account => {
        console.log(account.projectRole.id + " => " + account.currentProjectRoleId);
        const role = _.findWhere($scope.roles, {id: account.currentProjectRoleId});

        accountService.UpdateRoleForProject($scope.project, account, role, () => refreshInvites(), () => refreshInvites());
      };

      $scope.savePassword = password => {
        $scope.savingPassword = true;

        app.services.project.ProjectPasswordService.Save(projectPasswordService.Create($scope.project.id, password.password)).then(() => {
          $scope.savingPassword = false;
          password.password = "";
          refreshPasswords();
        }, () => {
          $scope.savingPassword = false
        });
      };

      $scope.removePassword = password => projectPasswordService.Delete(password, () => refreshPasswords());

      $scope.saveRole = (role, isNew) => {
        $scope.savingRole = true;

        if (!role || !role.name) {
          $scope.savingRole = false;
          return;
        }

        const newRole = new app.model.authentication.Role(role.id, $scope.project.id, role.name, role.permissions, role.tagRestriction);

        roleService.save(newRole, savedRole => {
          role.name = "";
          $scope.savingRole = false;
          if (isNew) {
            savedRole.isNew = isNew;
            $scope.roles.push(savedRole);
          } else {
            refreshRoles();
          }
        }, () => $scope.savingRole = false);
      };

      $scope.$on("SaveRole", (evt, role) => $scope.saveRole(role, false));

      $scope.removeRole = role => {
        $scope.savingRole = true;

        if (!role || !role.name) {
          $scope.savingRole = false;
          return;
        }

        roleService.delete(role, () => {
          notificationService.addSuccess({
            title: "Role removed successfully",
            timeout: 2500
          });

          $scope.savingRole = false;
          refreshRoles();

        }, () => {
          $scope.savingRole = false;
          refreshRoles();
        });
      };

      $scope.$on("RemoveRole", (evt, role) => $scope.removeRole(role));

      $scope.$watch("newLoadFileFormat.projectId", (val: string) => {
        if (val) {
          $scope.checkedLoadFileFormats = [];

          loadFileFormatService.FindAll({projectId: val}).then(formats => $scope.loadFileFormats = formats);
        }
      });

      $scope.formatChange = format => {
        if (format.checked) {
          $scope.checkedLoadFileFormats.push({id: format.id, format: format});
        } else {
          $scope.checkedLoadFileFormats = _.reject($scope.checkedLoadFileFormats, (f: any) => f.id === format.id);
        }
      };

      $scope.importLoadFileFormats = () => {
        const numToComplete = $scope.checkedLoadFileFormats.length;
        let numComplete = 0;

        for (let i = 0; i < $scope.checkedLoadFileFormats.length; i++) {
          const formatToSave = angular.copy($scope.checkedLoadFileFormats[i].format);
          delete formatToSave.id;
          formatToSave.projectId = $scope.project.id;
          $scope.newLoadFileFormat.saving = true;

          // Create a new one
          loadFileFormatService.Save(formatToSave).then(() => {
            numComplete++;
            if (numToComplete === numComplete) {
              $scope.newLoadFileFormat.saving = false;

              notificationService.addSuccess({
                title: numToComplete + " Load File Formats Imported",
                timeout: 2500
              });
            }
          }).catch(() => {
            numComplete++;
            if (numToComplete === numComplete) {
              $scope.newLoadFileFormat.saving = false;
            }
          });
        }

      };

      $scope.openHibernateDialog = () => {
        $uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/project/dialog_hibernate.html",
          controller: "HibernateModalController",
          scope: $scope,
          resolve: {
            project: () => $scope.project
          }
        });
      };

      $scope.hibernate = () => {

        if ($scope.account.mfaEnabled) {
          $scope.openHibernateDialog();
        } else {

          let mfaModalInstance = $uibModal.open({
            backdrop: true,
            keyboard: true,
            backdropClick: true,
            templateUrl: "partials/mfa/dialog_mfa.html",
            controller: "MFAModalController",
            scope: $scope,
            resolve: {
              account: () => $scope.account
            }
          });

          mfaModalInstance.result.then(success => success && $scope.openHibernateDialog());
        }
      };

      $scope.openReActivateDialog = () => {
        $uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/project/dialog_reactivate.html",
          controller: "ReActivateModalController",
          scope: $scope,
          resolve: {
            project: () => $scope.project
          }
        });
      };

      $scope.reactivate = () => {
        if ($scope.account.mfaEnabled) {
          $scope.openReActivateDialog();
        } else {
          const mfaModalInstance = $uibModal.open({
            backdrop: true,
            keyboard: true,
            backdropClick: true,
            templateUrl: "partials/mfa/dialog_mfa.html",
            controller: "MFAModalController",
            scope: $scope,
            resolve: {
              account: () => $scope.account
            }
          });

          mfaModalInstance.result.then(success => success && $scope.openReActivateDialog());
        }
      };

      $scope.openDeleteDialog = () => {
        $uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/project/dialog_delete.html",
          controller: "ProjectDeleteModalController",
          scope: $scope,
          resolve: {
            project: () => $scope.project
          }
        });
      };

      $scope.delete = () => {
        if ($scope.account.mfaEnabled) {
          $scope.openDeleteDialog();
        } else {
          const mfaModalInstance = $uibModal.open({
            backdrop: true,
            keyboard: true,
            backdropClick: true,
            templateUrl: "partials/mfa/dialog_mfa.html",
            controller: "MFAModalController",
            scope: $scope,
            resolve: {
              account: () => $scope.account
            }
          });

          mfaModalInstance.result.then(success => success && $scope.openDeleteDialog());
        }
      };

      $scope.saveRemoteCollection = remoteCollection => {
        $scope.savingRemoteCollection = true;

        const data = _.pick(remoteCollection, "custodianName", "custodianEmailAddress", "custodianPhysicalAddress");

        httpService.$http({
          method: "POST",
          url: configService.getServerBaseUrl() + "/project/" + $scope.project.id + "/remoteCollection",
          data: data
        }).success(() => {
          $scope.savingRemoteCollection = false;

          notificationService.addSuccess({
            title: "Remote Collection Successfully Requested",
            description: "We will be in contact shortly with the details",
            timeout: 5000
          });

        }).error(() => {
          $scope.savingRemoteCollection = false;
          $scope.remoteCollectionSuccess = false;
        });
      };
    }
  }

  frontendApp.controller("ProjectAdminController", ["$scope", "$rootScope", "$routeParams", "$uibModal", "$location", "HttpService", "CollectionService", "OrganizationService", "ProjectService", "NotificationService", "NavigationService", "AccountService",
    "InviteService", "ProjectPasswordService", "RoleService", "PermissionService", "LoadFileFormatService", "ProjectStatusService", "BillingService", "AuditLogService", "ReportService", "ConfigService", "$sce", Factory.Create(ProjectAdminController)]);
}
